import { FormattedMessage } from 'react-intl';
import { orderFeatures } from './order-about-messages';
import { OrderAboutProps } from './types';

export const OrderAbout = ({ purchaseType }: OrderAboutProps) => (
  <>
    <h3 className="m-2 py-2">
      <FormattedMessage
        id="payment.thankyou.order.about"
        defaultMessage="What's included with your edX order"
        description="Order about section"
      />
    </h3>
    {orderFeatures(purchaseType).map((feature, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <p className="m-2 py-2" key={index}>
        <b>{feature.title}</b>
        &nbsp; {feature.description}
      </p>
    ))}
  </>
);
